"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SocketGateway", {
    enumerable: true,
    get: function() {
        return SocketGateway;
    }
});
const _crypto = /*#__PURE__*/ _interop_require_default(require("crypto"));
const _common = require("@nestjs/common");
const _core = require("@nestjs/core");
const _socketio = require("socket.io");
const _passport = require("@nestjs/passport");
const _executioncontexthost = require("@nestjs/core/helpers/execution-context-host");
const _websockets = require("@nestjs/websockets");
const _utils = require("~/utils");
const _jwtstrategy = require("~/strategies/jwt.strategy");
const _telemetryservice = require("~/services/telemetry.service");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function getHash(str) {
    return _crypto.default.createHash('md5').update(str).digest('hex');
}
const url = new URL(process.env.NC_PUBLIC_URL || `http://localhost:${process.env.PORT || '8080'}/`);
let namespace = url.pathname;
namespace += namespace.endsWith('/') ? '' : '/';
let SocketGateway = class SocketGateway {
    async onModuleInit() {
        this.server.use(async (socket, next)=>{
            try {
                const context = new _executioncontexthost.ExecutionContextHost([
                    socket.handshake
                ]);
                const guard = new ((0, _passport.AuthGuard)('jwt'))(context);
                await guard.canActivate(context);
            } catch (unused) {}
            next();
        }).on('connection', (socket)=>{
            var _socket_handshake_user, _socket_handshake;
            this.clients[socket.id] = socket;
            const id = getHash((process.env.NC_SERVER_UUID || _utils.T.id) + (socket == null ? void 0 : (_socket_handshake = socket.handshake) == null ? void 0 : (_socket_handshake_user = _socket_handshake.user) == null ? void 0 : _socket_handshake_user.id));
            socket.on('page', (args)=>{
                // T.page({ ...args, id });
                this.telemetryService.sendEvent(_extends({
                    evt_type: '$pageview'
                }, args, {
                    id
                }));
            });
            socket.on('event', (_0)=>{
                let { event } = _0, args = _object_without_properties_loose(_0, [
                    "event"
                ]);
                // T.event({ ...args, id });
                this.telemetryService.sendEvent(_extends({
                    evt_type: event
                }, args, {
                    id
                }));
            });
        });
    }
    get io() {
        return this.server;
    }
    constructor(jwtStrategy, telemetryService, httpAdapterHost){
        this.jwtStrategy = jwtStrategy;
        this.telemetryService = telemetryService;
        this.httpAdapterHost = httpAdapterHost;
        // private server: HttpServer;
        this.clients = {};
        this._jobs = {};
    }
};
_ts_decorate([
    (0, _websockets.WebSocketServer)(),
    _ts_metadata("design:type", typeof _socketio.Server === "undefined" ? Object : _socketio.Server)
], SocketGateway.prototype, "_io", void 0);
_ts_decorate([
    (0, _websockets.WebSocketServer)(),
    _ts_metadata("design:type", typeof _socketio.Server === "undefined" ? Object : _socketio.Server)
], SocketGateway.prototype, "server", void 0);
SocketGateway = _ts_decorate([
    (0, _websockets.WebSocketGateway)({
        cors: {
            origin: '*',
            allowedHeaders: [
                'xc-auth'
            ],
            credentials: true
        },
        namespace
    }),
    (0, _common.Injectable)(),
    _ts_param(2, (0, _common.Inject)(_core.HttpAdapterHost)),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jwtstrategy.JwtStrategy === "undefined" ? Object : _jwtstrategy.JwtStrategy,
        typeof _telemetryservice.TelemetryService === "undefined" ? Object : _telemetryservice.TelemetryService,
        typeof _core.HttpAdapterHost === "undefined" ? Object : _core.HttpAdapterHost
    ])
], SocketGateway);
